import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login", { replace: true });
      return;
    }
    if (roles && !roles.includes(user.role)) {
      const roleRoutes = {
        "super-admin": "/admin",
        admin: "/admin",
        operator: "/operator",
        client: "/client",
      };
      navigate(roleRoutes[user.role] || "/", { replace: true });
      return;
    }
    setChecked(true);
  }, [user, loading, roles, navigate]);

  if (loading || !checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-6 h-6 border-2 border-[#002FA7] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return children;
}
